import React from 'react';
import styled from 'styled-components';

const BuyButton = styled.li`
  background: rgb(121,9,49);
  background: linear-gradient(90deg, rgba(121,9,49,1) 35%, rgba(255,0,31,1) 100%); 
  fontFamily: 'sans-serif',
  fontWeight: 'normal',
`;

function Purchase(props) {
  return (
    <>
      <ul id="home-list" style={{ listStyle: 'none' }}>
        <a
          href="https://utahsymphony.org/tickets/single-concert/?utm_source=Online%20Playbill%20Mills%20Publishing"
          target="_blank"
          rel="noopener noreferrer"
        >
          <BuyButton>🎟 PURCHASE TICKETS</BuyButton>
        </a>
      </ul>
    </>
  );
}

export default Purchase;
